import { Button } from '@mui/material';
import { memo } from 'react';

const PrimaryButton = ({ label, onClick, disabled = false, startIcon }) => (
  <Button
    variant="contained"
    color="primary"
    onClick={onClick}
    disabled={disabled}
    startIcon={startIcon}
    sx={{ background:"#b5dcf2",color:"black", px: 2,py:0.5, fontSize: '0.75rem', fontWeight: 600, borderRadius: 0.5}}
  >
    {label}
  </Button>
);

export default memo(PrimaryButton);
